<template>
    <inertia-link
        :href="href"
        class="text-grey-dark">
        <div class="row space-y-4" :class="{'lg:space-y-0': split}">
            <div class="col-full" :class="{'lg:col-1/2': split}">
                <PostThumbnail :post="post"/>
            </div>
            <div class="col-full" :class="{'lg:col-1/2': split}">
                <h4 class="font-semibold text-lg leading-tight mb-4">{{ post.title }}</h4>
                <div class="text-sm" v-html="post.summary"/>
            </div>
        </div>
    </inertia-link>
</template>

<script>

import PostThumbnail from "@app/Shared/Components/PostThumbnail";
import {PostType} from "@admin/Lib/Enums";

export default {

    name: "PostTile",

    props: {
        post: {
            type: Object,
            required: true,
        },
        split: {
            type: Boolean,
            default: true
        }
    },

    components: {
        PostThumbnail
    },

    computed: {
        href() {
            switch (this.post.type) {
                case PostType.Tutorial:
                    return `/tutorial/${this.post.id}`
                case PostType.CaseReport:
                    return `/case-report/${this.post.id}`
            }
        },
    }
};

</script>
